var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBottomPointer = function SvgBottomPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M.5 0h18-2.172a2 2 0 0 0-1.414.586l-4 4a2 2 0 0 1-2.828 0l-4-4A2 2 0 0 0 2.672 0H.5Z",
    fill: "#14161A"
  })));
};
export { SvgBottomPointer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDE5IDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuOSIgZD0iTTAuNSAtMS41NzM2MWUtMDZMMTguNSAwTDE2LjMyODQgLTEuODk4NDVlLTA3QzE1Ljc5OCAtMi4zNjIxN2UtMDcgMTUuMjg5MyAwLjIxMDcxNCAxNC45MTQyIDAuNTg1Nzg2TDEwLjkxNDIgNC41ODU3OUMxMC4xMzMyIDUuMzY2ODMgOC44NjY4MyA1LjM2NjgzIDguMDg1NzkgNC41ODU3OEw0LjA4NTc5IDAuNTg1Nzg1QzMuNzEwNzEgMC4yMTA3MTIgMy4yMDIwMSAtMS4zMzczOWUtMDYgMi42NzE1NyAtMS4zODM3N2UtMDZMMC41IC0xLjU3MzYxZS0wNloiIGZpbGw9IiMxNDE2MUEiLz4KPC9zdmc+Cg==";